<div class="alert text-center" [class]="alertClass" role="alert">
  <!--<header class="alert-heading">
    <fa-icon [icon]="icon"></fa-icon>
  </header>-->
  <main>
    {{error}}
  </main>
</div>
